/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgTriangle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M10.65 2.552a2.75 2.75 0 013.701.97l.002.004 8.477 14.15a2.75 2.75 0 01-2.352 4.125H3.522a2.75 2.75 0 01-2.351-4.125l.006-.01 8.47-14.14.002-.004a2.75 2.75 0 011.002-.97zM12 3.7a1.25 1.25 0 00-1.068.6V4.3L2.466 18.431a1.25 1.25 0 001.068 1.87h16.93a1.25 1.25 0 001.068-1.87L13.07 4.301l-.001-.002a1.25 1.25 0 00-1.068-.6z'
      />
    </svg>
  );
}

export default SvgTriangle;
